import React, { Fragment } from 'react';
import moment from 'moment';
import parse from 'html-react-parser';
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
// child components
import LanguageComponent from '../language-selector/language.component';
// styles
const styles = require('./declaration-link.scss');
const logo = require('../../images/logo_airportr.svg');
// images
import headerImage from '../../images/progress_header_5.svg';
import frameIcon from '../../images/declare_frameIcon.svg';
// globals
import { GET_DECLARATAION } from '../../globals';

const API_PATH = process.env.REACT_APP_API_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
  'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY
};


interface IProps {
  trackingData: any;
  userBookingRef: any;
  userEmail: any;
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
}
interface IState {
  trackingData: any;
  userBookingRef: any;
  userEmail: any;
  decalrationData: any;
  responseStatus: number,
  open: boolean
}
interface CustomDeclarationRequest {
  bookingReference?: string;
  bookingJourneyReference?: string;
}

class DeclarationLink extends React.Component<IProps, IState> {
  public data: any;
  public wrapperRef;
  constructor(props: any) {
    super(props);
    this.state = {
      trackingData: props.trackingData,
      userBookingRef: props.userBookingRef,
      userEmail: props.userEmail,
      decalrationData: '',
      responseStatus: null,
      open: false
    }
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  private customDeclaration() {
    const request: CustomDeclarationRequest = {
      bookingReference: this.state.userBookingRef,
      bookingJourneyReference: this.state.trackingData.bookingJourneyReference
    }
    portrSDK.getTrackingDataWithHeader(
      API_PATH,
      GET_DECLARATAION,
      'post',
      null,
      request,
      header
    )
      .then((data: any) => {
        this.setState({ decalrationData: data })
        const dataStatus = this.state.decalrationData
        if (dataStatus.data !== undefined) {
          this.setState({ responseStatus: dataStatus.data.responseStatus })
          console.log(this.state.responseStatus !== 3);
        }
      })
      .catch((error: any) => {
        console.log('error')
        // this.setState({ currentView: 'credentials' });
        //   this.setState({ bookingNotFound: true });
        //   this.componentVars.queryParams.bookingRef = null;
        //   this.componentVars.queryParams.email = null;
      });
  }
  componentDidMount() {
    this.customDeclaration();
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ open: false })
    }
  }

  public render() {
    const { language, multiLang } = this.props;
    this.data = this.state.decalrationData;
    const error = multiLang[`errortextCustomsdeclarationdocument${language}`];
    const declarationContent = (
      <div className={styles.section}>
        <div ref={this.wrapperRef} className={styles.dropdown} onClick={() => this.setState({ open: !this.state.open })}>
          <span>
            {this.state.open}
            {multiLang[`selectCustomDeclaration${language}`]} <i className={styles.icon}>chevron</i>
          </span>
          {
            this.state.open && <div className={styles.menu}>
              <div className={styles.dropdown_container} >
                <ul className={styles.dropdown_menu}>
                  <li className={styles.dropdown_item} onClick={(e) => { this.setState({ open: false }) }} ><a href='#gvadeclaration'>{multiLang[`GVACustomsDeclaration${language}`]}</a></li>
                  <li className={styles.dropdown_item} onClick={(e) => { this.setState({ open: false }) }} ><a href='#zrhdeclaration'>{multiLang[`ZRHCustomsDeclaration${language}`]}</a></li>
                </ul>
              </div>
            </div>
          }
        </div>
        <div className={styles.detailRow}>
          <div className={styles.detailColumn}>
            <span className={styles.passengerName}><b>{multiLang[`leadPassenger${language}`]}:</b> {this.data.passengerFirstName} {this.data.passengerLastName}</span>
            <span className={styles.bookingRef}><b>{multiLang[`bookingReference${language}`]}:</b> {this.state.userBookingRef}</span>
          </div>
          <div className={styles.detailColumn}>
          {this.data.responseStatus === 1 ? this.data.virtualBagClassification.map( (item, index) => {
            return (<span key={index} className={styles.bagCount}>{item.count} {item.type === 1 ? multiLang[`ofBags${language}`] : item.type === 2 ? multiLang[`ofChildBabyEquipment${language}`] : item.type === 3 ? multiLang[`ofSportsEquipmentOversize${language}`] : '-'}</span>)
          })
          : '-'}
          </div>
        </div>
        <div className={styles.detailContent}>
          <h3>{multiLang[`generalHeading${language}`]}</h3>
          {parse(multiLang[`GVAGeneralDescription${language}`])}

          <h3>{multiLang[`GVACustomsAuthorisations${language}`]}</h3>
          {parse(multiLang[`GVACustomsAuthorisationsDescription${language}`])}

          <h3>{multiLang[`customDeclaration${language}`]}</h3>

          <h2 id='gvadeclaration'>{multiLang[`GVACustomsDeclaration${language}`]}</h2>

          <div className={styles.frameIcon}>
            <img src={frameIcon} />
          </div>

          {parse(multiLang[`GVACustomsDeclarationDescription${language}`])}

          <h3>{multiLang[`GVAThreatAction${language}`]}</h3>
          {parse(multiLang[`GVAThreatActionDescription${language}`])}

          <h3>{multiLang[`GVAPowerAttorney${language}`]}</h3>
          {parse(multiLang[`GVAPowerAttorneyDescription${language}`])}

          <h3>{multiLang[`GVARightObligations${language}`]}</h3>
          {parse(multiLang[`GVARightObligationsDescription${language}`])}

          <h3>{multiLang[`GVAAdditionalCharges${language}`]}</h3>
          {parse(multiLang[`GVAAdditionalChargesDescription${language}`])}

          <h3>{multiLang[`GVATerminationAttorney${language}`]}</h3>
          {parse(multiLang[`GVATerminationAttorneyDescription${language}`])}

          <h3>{multiLang[`GVAJurisdictionAndApplicableLaw${language}`]}</h3>
          {parse(multiLang[`GVAJurisdictionAndApplicableLawDescription${language}`])}

          <h2 id='zrhdeclaration'>{multiLang[`ZRHCustomsDeclaration${language}`]}</h2>

          <div className={styles.frameIcon}>
            <img src={frameIcon} />
          </div>

          {parse(multiLang[`ZRHCustomsDeclarationDescription${language}`])}

          <h3>{`${multiLang[`ZRHTermsOfUse${language}`]} / ${multiLang[`ZRHPowerOfAttorney${language}`]}`}</h3>

          <h3>{multiLang[`ZRHTermsOfUse${language}`]}</h3>

          <h3>{multiLang[`generalHeading${language}`]}</h3>
          {parse(multiLang[`ZRHGeneralDescription${language}`])}

          <h3>{multiLang[`ZRHCustomsAuthorisations${language}`]}</h3>
          {parse(multiLang[`ZRHCustomsAuthorisationsDescription${language}`])}

          <h3>{multiLang[`ZRHThreatOfLegalAction${language}`]}</h3>
          {parse(multiLang[`ZRHThreatOfLegalActionDescription${language}`])}

          <h3>{multiLang[`ZRHPowerOfAttorney${language}`]}</h3>
          {parse(multiLang[`ZRHPowerOfAttorneyDescription${language}`])}

          <h3> {multiLang[`ZRHRightsAndDuties${language}`]} </h3>
          {parse(multiLang[`ZRHRightsAndDutiesDescription${language}`])}

          <h3>{multiLang[`ZRHAdditionalCosts${language}`]}</h3>
          {parse(multiLang[`ZRHAdditionalCostsDescription${language}`])}

          <h3>{multiLang[`ZRHTerminationAttorney${language}`]}   </h3>
          {parse(multiLang[`ZRHTerminationAttorneyDescription${language}`])}

          <h3>{multiLang[`ZRHJurisdictionAndApplicableLaw${language}`]}</h3>
          {parse(multiLang[`ZRHJurisdictionAndApplicableLawDescription${language}`])}

        </div>
        <br />

        <div className={styles.detailRow}>
          <span><b>{multiLang[`signed${language}`]}:</b></span>
          <span className={styles.passengerSignature}>{this.data.passengerFirstName} {this.data.passengerLastName}</span>
        </div>
        <div className={styles.detailRow}>
          <span><b>{multiLang[`name${language}`]}:</b></span>
          <span className={styles.passengerName}>{this.data.passengerFirstName} {this.data.passengerLastName}</span>
        </div>
        <div className={styles.detailRow}>
          <span><b>{multiLang[`date${language}`]}:</b></span>
          <span className={styles.passengerName}>{moment(this.data.dateTimeDocumentSigned).format('DD/MM/YYYY')}</span>
        </div>
      </div>
    );
    return (<Fragment>
      <div className={styles.timelineSuccess}>
        <div className={styles.wrapper}>
          <div className={styles.overview}>
            <button className={styles.btn}>
              <div className={styles.toggleIcons}>
                <i className={styles.icon}>timeline</i>
                <i className={styles.icon}>close</i>
              </div>
              <span className={styles.status}>
                {multiLang[`customDeclaration${language}`]}
              </span>
            </button>
            <button className={styles.btnRefresh}>
              <i className={styles.icon}>refresh</i>
            </button>
            <LanguageComponent selectedLanguage={this.props.languageCode}
              handleLanguageChange={this.props.handleLanguageChange} />
            <img className={styles.logo} src={logo} />
          </div>
          {/* <div className={styles.details}>
            {listTimelineSteps}
          </div> */}
        </div>
      </div>
      <div className={styles.mainContent}>
        <div className={styles.sectionWrapperContent}>
          <div className={styles.section}>
            <h1>
              {this.state.responseStatus !== 3 ?
                multiLang[`yourCustomsDeclaration${language}`] : error}
            </h1>
            <img className={styles.heroImg} src={headerImage} width='100%' />
          </div>
        </div>
        <div className={styles.sectionWrapperSlider} >
          {this.state.responseStatus !== 3 ?
            declarationContent : null}
        </div>
      </div>
    </Fragment>
      // <Redirect to='/' />
    );
  }

}

export default DeclarationLink;



// WEBPACK FOOTER //
// ./src/components/declaration-link/declaration-link.tsx